import {UserContextProvider} from "@/components/context/UserContextProvider.tsx";
import {Outlet} from "react-router";

export const PrivateStatusPageLayout = () => (
  <UserContextProvider>
    <Outlet />
  </UserContextProvider>
);
